import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { DATE_RANGE_INPUT_CATEGORY_KEY, DATE_RANGE_INPUT_COMPONENT_KEY } from '../DateRangeInput.meta.js';

export default InjectedStyledComponent('div', DATE_RANGE_INPUT_CATEGORY_KEY, DATE_RANGE_INPUT_COMPONENT_KEY, [
	'selectedYear',
]);
